exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-hidden {\r\n  visibility: hidden;\r\n}\r\n.loader-overlay {\r\n  width: 190px;\r\n  top: 20%;\r\n  left: 0%;\r\n  opacity: 1;\r\n  z-index: 500000;\r\n  background: #fff;\r\n  border-radius: 15px;\r\n  padding: 15px;\r\n  position: absolute;\r\n  right: 0;\r\n  margin: 0 auto;\r\n  text-align: center;\r\n  box-shadow: 0px 2px 10px #bbbbbb;\r\n}\r\n\r\n.loading-icon {\r\n  background: #fff;\r\n  border-radius: 20px;\r\n}\r\n.loading-icon span { margin-left: 10px; color: #767676; font-family: 'Hind';}\r\n\r\n.loader-block {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 9999;\r\n  background: rgba(0, 0, 0, 0.1);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/loader/loader.component.css
// module id = ../../../../../src/app/loader/loader.component.css
// module chunks = main